module.exports = __webpack_public_path__ + "img/userDark.2e459309.svg";